<template>
  <div>
    <div id="bg" v-on:click="clearpopup"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <SubHeaderWithSidebar :title="headerTitle" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="quizWrap">
            <h5 class="subtitle">
              {{itemTitle}}
              <span>{{itemIndex}}</span>
            </h5>

            <!-- p283 경우 -->
            <ItemOnlyText :issent="issent" v-if="this.$store.state.itemMeta.bogi_deco === 'text'" />
            <ItemWithImage
              :issent="issent"
              v-if="this.$store.state.itemMeta.bogi_deco === 'image'"
            />
            <!-- survey -->

            <a
              v-if="!issent && !alreadytimeout"
              href="#"
              class="submitbtn"
              title="제출하기"
              @click.prevent="sendAnswer"
            >
              <span>
                <img src="@/assets/img/check.png" alt="정답 제출하기" />
              </span>제출하기
            </a>

            <a v-if="issent" href="#" class="submitbtn" title>제출 완료</a>
            <a v-if="alreadytimeout" href="#" class="submitbtn" title>타임아웃</a>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import ItemWithImage from "@/components/item/ItemWithImage";
import ItemOnlyText from "@/components/item/ItemOnlyText";
import sideMixin from "@/components/SideMixin";

export default {
  mixins: [sideMixin],
  components: { ItemOnlyText, ItemWithImage },
  components: { SubHeaderWithSidebar, ItemWithImage, ItemOnlyText },
  computed: {
    itemTitle() {
      return this.$store.state.itemMeta.item_type === "quiz" ? "Quiz" : "Poll";
    },
    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    },
    itemIndex() {
      return this.$store.state.itemMeta.index;
    },
    alreadytimeout() {
      if (this.issent == false && this.$store.state.item_timeout) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function() {
    return {
      issent: false
    };
  },
  methods: {
    sendAnswer() {
      //done: send answer with socket
      //done: change view to  waiting for result

      let my_answers = this.$store.state.itemMeta.my_answers;
      if (my_answers.size == 0) {
        alert("정답을 체크해주세요");
        return;
      }

      let itemMeta = this.$store.state.itemMeta;
      let payload = {};
      payload.classroom_id = this.$store.getters.getClassroomId;
      payload.paper_id = itemMeta.paper_id;
      payload.item_id = itemMeta.item_id;
      // payload.default_info = this.$store.getters.getDefaultInfo;
      payload.default_info = localStorage.getItem("default_info");
      payload.my_answers = [...my_answers];

      //todo check spend time to solve this quiz
      let st = this.$store.state.item_starttime;
      // let now = new Date();
      // st = this.moment().diff(st, "second");
      st = this.moment().diff(st); // milliseconds

      console.info(st);
      payload.time = st;
      let wrapper = {};
      wrapper.wayto = "ACTION_ITEM_ANSWER";
      wrapper.from = "";
      wrapper.to = "";
      wrapper.payload = payload;

      this.$store.dispatch("pushWSMessage", wrapper);
      this.issent = true;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>